import { render, staticRenderFns } from "./agentBindingMechanism.vue?vue&type=template&id=8f0795f4&scoped=true"
import script from "./agentBindingMechanism.vue?vue&type=script&lang=js"
export * from "./agentBindingMechanism.vue?vue&type=script&lang=js"
import style0 from "./agentBindingMechanism.vue?vue&type=style&index=0&id=8f0795f4&prod&lang=css"
import style1 from "./agentBindingMechanism.vue?vue&type=style&index=1&id=8f0795f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0795f4",
  null
  
)

export default component.exports